import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box } from '@mui/material';
import React from 'react';
import { getCardColors } from '../../Cards/cardColors';
import { IconDisplay } from './IconDisplay';
/**
 * Renders the icon section of a `Card`, applying color and layout styles.
 *
 * @template CardIconProps
 *
 * @param {CardIconProps} props - Props for the CardIcon component.
 * @param {React.ReactNode} [props.icon] - Optional icon to display. Defaults to AddCircleOutlineIcon.
 * @param {'blue' | 'green' | 'red' | 'yellow' | 'grey'} [props.iconColor] - The background color for the icon area.
 *
 * @returns {React.ReactElement} The styled icon container element.
 */
export const CardIcon = (props) => {
    var _a;
    const backgroundColor = getCardColors()[(_a = props.iconColor) !== null && _a !== void 0 ? _a : 'blue'];
    const sx = { display: 'flex', alignItems: 'center', justifyContent: 'center' };
    return (React.createElement(Box, { sx: Object.assign({ position: 'relative', backgroundColor: backgroundColor, overflow: 'hidden', borderTopLeftRadius: 4, borderBottomLeftRadius: 4 }, sx), "data-test": 'icon' },
        React.createElement(IconDisplay, null),
        React.createElement(Box, { sx: Object.assign({ position: 'relative', color: backgroundColor }, sx) }, props.icon ? props.icon : React.createElement(AddCircleOutlineIcon, null))));
};
